import './index.css';
import logo  from '../../assets/logo.png';
import ilustration from '../../assets/ilustration.png';

export const Home = ({setPage, page}) => {

    const dash = (event) => {
        event.preventDefault();
        setPage('Dashboard');
    }

    return(
        <div className='container-home'>
            <div className='container-main'>
            <img src= {logo} alt='logo'/>
            <h1>Centralize o controle das suas finanças</h1>
            <span>de forma rápida e segura</span>
            <button className='button-home' type='button' onClick={(event) => dash(event) }>Iniciar</button>
            </div>
            <img src= {ilustration} alt='ilustration'/>
        </div>
    )
}